import {useState, useEffect} from "react";
import {LocalizationProvider, TimePicker} from '@mui/x-date-pickers';
import {AdapterDateFns} from '@mui/x-date-pickers/AdapterDateFns';
import heLocale from "date-fns/locale/he";
import {FormControl,Button, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { DepartureIcon } from '../assets';
import { flightTimeValues } from "../data";
import {getLocalStorageKey} from "../utils";
import {CalcBestRoute} from "../airways";



export function RouteBack(props){

      const {mapUsed, planedRoute, setPlanedRoute,setAlertDialogOpen, setAlertDialogMessage, updateDepartureTime, departureTime, createAirTrafficRules, openAirways,setRouteBackDialogOpen, routeBackDialogOpen} = props

      const [dlgDepartureTime, setDlgDepartureTime] = useState(adjustBackTime);
    
      function adjustBackTime() {


        var depTime = new Date(departureTime.getTime());

        var fplSavedContent = getLocalStorageKey("fplSavedContent")

        if(fplSavedContent){
            var flightTimeText = fplSavedContent.flightTime
            if(flightTimeText){

                const index = flightTimeValues.findIndex((a) => a[0] === flightTimeText);

                if (index > -1) {
                    depTime.setMinutes(departureTime.getMinutes() + flightTimeValues[index][2])
                } else {
                    var flightTime = parseInt(flightTimeText) / 100
                    depTime.setHours(departureTime.getHours() + parseInt(flightTime) / 100)
                }
            }
        }
        return depTime;
      }

      useEffect(() => {
      if (routeBackDialogOpen) {
        setDlgDepartureTime(adjustBackTime());
      }
      // eslint-disable-next-line react-hooks/exhaustive-deps
      }, [routeBackDialogOpen]);

    // Close the dialog and calculate the best route
    // using the planned route and the departure time set in the dialog.    
    const closeDialog = ()=>{ 

        const fromTo = [planedRoute[planedRoute.length - 1],planedRoute[0]]
      
        const filteredRules = createAirTrafficRules(dlgDepartureTime,mapUsed)

        const timeCategory = updateDepartureTime(dlgDepartureTime)

        setRouteBackDialogOpen(false)

        CalcBestRoute(mapUsed,timeCategory, fromTo, setPlanedRoute, filteredRules, openAirways,setAlertDialogOpen, setAlertDialogMessage,false)
    }
    

    return (

        <Dialog className="fpl-submit" open={routeBackDialogOpen} onClose={closeDialog}>

        <div style={{textAlign: 'center'}}>
          <p></p>
          <DepartureIcon/>
        </div> 

        <DialogTitle  textAlign="center">זמן המראה חזרה</DialogTitle>

        <DialogContent dir="ltr">

      <LocalizationProvider
        dateAdapter={AdapterDateFns}
        adapterLocale={heLocale}
      >
        <FormControl variant='standard' sx={{ mt: 2, mr: 2, minWidth: 120 }} dir="ltr">
          <TimePicker
            // sx={{ m: 1, minWidth: 120 }}
            mode='24h'
            label='Departure Local Time'
            value={dlgDepartureTime}
            disablePast={true}
            minutesStep={5}
            disableIgnoringDatePartForTimeValidation = {true}
            onChange={(newValue) => {
              setDlgDepartureTime(newValue);
            }}
          />
        </FormControl>
      </LocalizationProvider>

        </DialogContent>

        <DialogActions>
          <Button variant="contained" onClick={closeDialog}> OK </Button>
        </DialogActions>
      </Dialog>
    );
}

export default RouteBack